/**
 * @fileoverview PUT handler for the "/comments/:target/threads/:thread_id/resolve" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { mutationCacheKeys } from "./constants";
import type { AppendAppGroupToUrl, ResolveCommentThreadProps, ResolveCommentThreadResult } from "./types";

export const resolveCommentThread = reactQueryMutationAdapter(
  mutationCacheKeys,
  (props: AppendAppGroupToUrl<ResolveCommentThreadProps>): Promise<ResolveCommentThreadResult> => {
    return fetch(
      `/comments/${props.target}/threads/${props.threadId}/resolve?app_group_id=${props.appGroupId}`,
      "PUT"
    );
  }
);
